import { useState, useEffect, useContext } from 'react';
import { FaDownload } from 'react-icons/fa';
import AuthContext from '../../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const PURCHASE_LABELS = {
    token_pack: 'Credit Pack — Pay As You Go',
    subscription: 'Subscription Plan',
    subscription_autopay: 'Subscription — Auto Pay',
    tokens: 'Credits Purchase',
    credits: 'Credits Purchase',
};

const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch { return dateStr; }
};

const BillingHistory = () => {
    const authCtx = useContext(AuthContext);
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!authCtx.token) return;
        fetch(`${API_URL}/payment_integration/invoices?per_page=50`, {
            headers: { 'Authorization': `Bearer ${authCtx.token}` },
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) setInvoices(data.invoices || []);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [authCtx.token, authCtx.user?.credits]);

    const handleDownload = async (orderId) => {
        try {
            const res = await fetch(`${API_URL}/payment_integration/invoices/${orderId}/pdf`, {
                headers: { 'Authorization': `Bearer ${authCtx.token}` },
            });
            if (!res.ok) return;
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `EcomBuddha_Invoice_${orderId}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        } catch {}
    };

    if (loading) return <div className="text-[#737373] text-sm">Loading billing history...</div>;
    if (invoices.length === 0) return null;

    return (
        <div id="billing-history" className="w-full flex flex-col gap-4 scroll-mt-8">
            <h3 className="text-[#505050] text-2xl font-semibold font-heading">Billing history</h3>
            <div className="flex flex-col gap-3">
                {invoices.map((item, index) => {
                    const label = PURCHASE_LABELS[item.purchase_type] || 'Payment';
                    const planId = item.meta?.plan_id;
                    const credits = item.meta?.credits;
                    const title = item.purchase_type === 'subscription' || item.purchase_type === 'subscription_autopay'
                        ? `${planId ? planId.charAt(0).toUpperCase() + planId.slice(1) : ''} Plan — Monthly`
                        : credits ? `${credits} Credits — Pay As You Go` : label;

                    return (
                        <div key={index} className="w-full px-5 py-3 bg-white/80 shadow-[0_0_134px_14px_rgba(120,179,243,0.06)] rounded-3xl outline outline-1 outline-[#D0E7FF] flex justify-between items-center">
                            <div className="flex flex-col gap-1 px-2">
                                <span className="text-[#505050] text-base font-semibold leading-6 font-sans">{title}</span>
                                <span className="text-[#737373] text-sm font-medium leading-6 font-sans">{formatDate(item.paid_at || item.created_at)}</span>
                            </div>
                            <div className="flex items-center gap-5">
                                <div className="px-4 py-1.5 bg-[#D0E7FF]/20 rounded-full outline outline-1 outline-[#78B3F3] flex items-center">
                                    <span className="text-[#2766AA] text-base font-semibold font-sans opacity-70">Paid</span>
                                </div>
                                <span className="text-[#505050] text-base font-semibold leading-6 font-sans">₹{item.amount?.toLocaleString('en-IN')}</span>
                                <button onClick={() => handleDownload(item.order_id)} className="px-4 py-3 rounded-2xl flex items-center gap-2.5 opacity-80 cursor-pointer hover:opacity-100 transition-opacity">
                                    <FaDownload className="w-4 h-4 text-[#2766AA]" />
                                    <span className="text-[#2766AA] text-base font-semibold">Download Invoice</span>
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default BillingHistory;
